export default __webpack_public_path__ + "static/media/lpyc.19a5f6d7.png";